// extracted by mini-css-extract-plugin
export var blockedMessage = "_95-3";
export var blockedOverlay = "_95-1";
export var fadeIn = "_95-2";
export var hereLink = "_95-0";
export var slideUp = "_95-4";